import * as THREE from "three";

export default function(color, scale) {
  Object.setPrototypeOf(this, new THREE.PointLight(color));
  this.name = "SecondaryLight";

  let xPosition = 0;
  let yPosition = 0;

  /*
   * @function - mouseMove
   * Sets xPosition and yPosition to make light follow cursor
   * @param - e: mousemove event argument
   */
  function mouseMove(e) {
    const reDefineX = e.pageX - window.innerWidth / 2;
    const reDefineY = e.pageY - window.innerHeight / 2;

    xPosition = (reDefineX * scale) / window.innerHeight;
    yPosition = -((reDefineY * scale) / window.innerHeight);
  }

  /*
   * @function - perform
   * Action of agents oriented programming 3d interfaces
   * @param - scene (ThreeJS Scene Instance): Scene instance of the 3d scene
   */
  function perform() {
    this.position.x = 2 * xPosition + 3 * scale;
    this.position.y = 2 * yPosition;
  }

  this.perform = perform;
  this.mouseMove = mouseMove;
}
